import React, { Suspense } from "react";
import RouterWrapper from "./router/RouterWrapper";
import { BrowserRouter as Router } from "react-router-dom";

import { LogProvider } from "../../shared/hooks/logsContext";
import AppController from "../../shared/hooks/AppController";
import ErrorBoundaryContainer from "./ErrorBoundary/ErrorBoundaryContainer";
const App = () => {
  return (
    <Suspense fallback={null}>
      <Router>
        <LogProvider>
          <ErrorBoundaryContainer>
            <AppController />
            <RouterWrapper />
          </ErrorBoundaryContainer>
        </LogProvider>
      </Router>
    </Suspense>
  );
};

export default App;
